import { NotePencilIcon } from '@phosphor-icons/react'
import { useMediaQuery } from '@mui/material'

import { BaseModal2 } from '@components/modals/BaseModal2'
import { emotionTheme } from '@styles/theme'

import type { BaseModalProps } from '@components/modals/BaseModal/types'

import * as S from '../JustifyingDeviationsModal/styles'

type BlockDeviationModalProps = Pick<BaseModalProps, 'open' | 'onClose'> & {
  message?: string
}

export const BlockDeviationModal = ({ open, onClose, message }: BlockDeviationModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  return (
    <BaseModal2
      open={open}
      title="Justificar Desvio"
      headerIcon={<NotePencilIcon />}
      onClose={onClose}
      width={isMobile ? 'calc(100% - 20px)' : 480}
      heightContainer="auto"
      footer={{
        cancelButtonText: 'Cancelar',
        cancelButtonMinWidth: '100%'
      }}
    >
      <S.Title>
        {message ?? (
          <><strong>Atenção:</strong> Para prosseguir para a próxima etapa do fluxo de aprovação da prévia, é necessário justificar o(s) desvio(s).</>
        )}
      </S.Title>
    </BaseModal2>
  )
}
